/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

// From https://stackoverflow.com/questions/21825157/internet-explorer-11-detection
const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

export default isIE11;